import {
  FormControlLabel,
  Button,
  Grid,
  makeStyles,
  IconButton,
  Checkbox,
  TableContainer,
  Paper,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Box,
  Table,
  Radio,
  TextField,
  CircularProgress,
  Dialog,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { appUrl } from "../../../../../../utils/config";
import StyledDialog from "../MessageDialogBox";
import BackDropLoading from "../../../common/models/BackDrop";
import { useDispatch } from "react-redux";
import {
  DESTROY_BACKDROP,
  OPEN_BACKDROP,
} from "../../../../containers/actions/types";

const useStyles = makeStyles((theme) => ({
  backContainer: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    fontWeight: 500,
  },
  titleContainer: {
    backgroundColor: "#e3eef3",
    padding: "10px",
    marginBottom: "10px",
  },
  borders: {
    border: '2px solid #707070',
    display: 'flex',
    width: '1.6rem',
    backgroundColor: 'grey',
  },
}));

export default function ViewDetailAllocation() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const SLID = queryParams.get("SLID");
  const selectedRowData = location?.state?.selectedRowData;
  const dispatch = useDispatch();
  const [mainTableData, setMainTableData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openMsgDialog, setOpenMsgDialog] = useState(false);
  const [openMsgErrDialog, setOpenMsgErrDialog] = useState(false);
  const [mappingObj, setMappingObj] = useState({});
  const [openRows, setOpenRows] = useState({}); // State for collapse button
  const [lotSelection, setLotSelection] = useState({}); // Stores selection states per row
  // const [disableSaveChangesBtn, setDisableSaveChangesBtn] = useState(true);
  const [refreshTableData, setRefreshTableData] = useState(false);
  const [finalPayload, setFinalPayload] = useState([]);

  useEffect(() => {
    setLoading(true);
    const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchComponentAllocationForPOLine/${SLID}`;
    axios
      .get(url)
      .then((res) => {
        if (res.data.status) {
          // setError(null);
          setMainTableData(res?.data?.data?.componentAllocationDataList);
          let mappingObject = {};
          res.data.data.componentAllocationDataList.forEach((item) => {
            const { componentCode } = item.componentAllocationDetails;
            mappingObject[componentCode] = {
              inventoryDetails: item.inventoryDetails,
              componentAllocationDetails: item.componentAllocationDetails,
              lotNumberAllocationDetails: item.lotNumberAllocationDetails,
            };
          });
          setMappingObj(mappingObject);
        }
      })
      .catch((err) => {
        setError(err.message);
        console.error("Error=> ", err.message);
      })
      .finally(() => setLoading(false));
  }, [SLID, refreshTableData]);

  const classes = useStyles();
  const handleBack = () => {
    window.history.back();
  };

  // Toggle collapsible rows
  const handleRowToggle = (rowId) => {
    // setOpenRows((prev) => ({ ...prev, [rowId]: !prev[rowId] }));
    setOpenRows((prev) => ({ [rowId]: !prev[rowId] }));
  };

  // Handle Lot Selection Change
  const handleSelectionChange = (rowId, lotNumber, quantity) => {
    // lotNumber = Number(lotNumber);
    // lotNumber = String(lotNumber);
    setLotSelection((prev) => {
      const savedVal = prev[rowId]?.lotAndValue;
      const currentState = prev[rowId] || {
        useSingleLot: true,
        selectedLot: null,
        selectedLots: [],
        lotAndValue: {
          [lotNumber]: "",
        },
      };

      if (currentState.useSingleLot) {
        // setDisableSaveChangesBtn(
        //   prev[rowId]?.selectedLot && prev[rowId]?.selectedLot === lotNumber
        //     ? true
        //     : false
        // );
        return {
          ...prev,
          [rowId]: {
            ...currentState,
            selectedLot:
              prev[rowId]?.selectedLot && prev[rowId]?.selectedLot === lotNumber
                ? null
                : lotNumber,
            selectedLots: [],
            lotAndValue: {
              // ...savedVal,
              [lotNumber]:
                prev[rowId]?.selectedLot &&
                prev[rowId]?.selectedLot === lotNumber
                  ? ""
                  : quantity,
            },
          },
        };
      } else {
        const updatedLots = currentState.selectedLots.includes(lotNumber)
          ? currentState.selectedLots.filter((lot) => lot !== lotNumber)
          : [...currentState.selectedLots, lotNumber];

        // if (prev?.[rowId]?.lotAndValue) {
        //   let totalSum = 0;
        //   for (let [key, vals] of Object.entries(prev?.[rowId]?.lotAndValue)) {
        //     if (key != lotNumber) {
        //       totalSum = totalSum + vals;
        //     }
        //   }

        //   let compareVal = Number(totalSum);
        //   if (quantity != compareVal) {
        //     setDisableSaveChangesBtn(true);
        //   } else {
        //     setDisableSaveChangesBtn(false);
        //   }
        // }

        return {
          ...prev,
          [rowId]: {
            ...currentState,
            selectedLots: updatedLots,
            selectedLot: null,
            lotAndValue: {
              ...savedVal,
              [lotNumber]: "",
            },
          },
        };
      }
    });

    setFinalPayload(
      finalPayload.filter(
        (val) => val?.componentAllocationDetails?.componentCode !== rowId
      )
    );
  };

  // Handle checkbox toggle for "Use RM/PM material from one lot only"
  const handleToggleSingleLot = (rowId, checked) => {
    setLotSelection((prev) => ({
      ...prev,
      [rowId]: {
        useSingleLot: checked,
        selectedLot: checked ? null : prev[rowId]?.selectedLot,
        selectedLots: checked ? [] : prev[rowId]?.selectedLots || [],
      },
    }));

    // setDisableSaveChangesBtn(true);
    setFinalPayload(
      finalPayload.filter(
        (val) => val?.componentAllocationDetails?.componentCode !== rowId
      )
    );
  };

  const handleQtyChange = (
    value,
    componentCode,
    lotNumber,
    bomQuantity,
    allocatedQuantity
  ) => {
    // let totalSum = 0;
    // if (allocatedQuantity.length > 0) {
    //   for (let val of allocatedQuantity) {
    //     if (val?.plannedAllocatedQuantity) {
    //       totalSum = totalSum + Number(val?.plannedAllocatedQuantity);
    //     }
    //   }
    // }
    // for (let [key, vals] of Object.entries(
    //   lotSelection[componentCode]?.lotAndValue
    // )) {
    //   if (key != lotNumber) {
    //     totalSum = totalSum + vals;
    //   }
    // }

    // let compareVal = Number(totalSum) + Number(value);
    // if (bomQuantity != compareVal) {
    //   setDisableSaveChangesBtn(true);
    // } else {
    //   setDisableSaveChangesBtn(false);
    // }

    setLotSelection((prev) => {
      const savedVal = prev[componentCode]?.lotAndValue;
      return {
        ...prev,
        [componentCode]: {
          ...prev[componentCode],
          lotAndValue: {
            ...savedVal,
            // ...prev[componentCode]?.lotAndValue,
            [lotNumber]: value,
          },
        },
      };
    });

    setFinalPayload(
      finalPayload.filter(
        (val) =>
          val?.componentAllocationDetails?.componentCode !== componentCode
      )
    );
  };

  // Save selected lot data for a row
  const handleSaveChanges = (rowId, lotArray) => {
    dispatch({
      type: OPEN_BACKDROP,
      backdropText: "Please wait. Saving ...",
    });
    const selection = lotSelection[rowId] || {
      useSingleLot: true,
      selectedLot: null,
      selectedLots: [],
    };

    const selectedData = selection.useSingleLot
      ? lotArray
          .filter((lot) => lot?.inventoryBatchNumber === selection?.selectedLot)
          ?.map((val) => ({
            lotNumber: val?.inventoryBatchNumber, //  Extract only lotNumber
            plannedAllocatedQuantity:
              lotSelection[rowId]?.lotAndValue[val?.inventoryBatchNumber], //  Extract plannedAllocatedQuantity
          }))
      : lotArray
          .filter((lot) =>
            selection.selectedLots.includes(lot.inventoryBatchNumber)
          )
          .map((val) => ({
            lotNumber: val?.inventoryBatchNumber, //  Extract only lotNumber
            plannedAllocatedQuantity:
              lotSelection[rowId]?.lotAndValue[val?.inventoryBatchNumber], //  Extract plannedAllocatedQuantity
          }));

    // console.log(`Selected Data for Row ${rowId}:`, selectedData);

    setTimeout(() => {
      setFinalPayload((prevPayload) => {
        const existingIndex = prevPayload.findIndex(
          (item) => item?.componentAllocationDetails?.componentCode === rowId
        );

        if (existingIndex !== -1) {
          const updatedPayload = [...prevPayload];
          updatedPayload[existingIndex] = {
            componentAllocationDetails:
              mappingObj[rowId].componentAllocationDetails,
            inventoryDetails: mappingObj[rowId].inventoryDetails,
            previousLotNumberAllocationDetails: mappingObj[rowId]?.lotNumberAllocationDetails?.filter((val) => {
              if (Array(selectedData) && selectedData.length > 0) {
                return !(selectedData?.filter((lot)=> lot?.lotNumber == val?.lotNumber).length > 0)
              } else {
                return true
              }
            }).map((lot) => ({
              lotNumber: lot?.lotNumber,
              plannedAllocatedQuantity: 0,
            })),
            lotNumberAllocationDetails: selectedData?.map((lot) => ({
              lotNumber: lot?.lotNumber,
              plannedAllocatedQuantity: Number(lot?.plannedAllocatedQuantity),
            })),
          };
          return updatedPayload;
        } else {
          return [
            ...prevPayload,
            {
              // componentAllocationDetails: {
              //   componentCode: rowId,
              // },
              componentAllocationDetails:
                mappingObj[rowId].componentAllocationDetails,
              inventoryDetails: mappingObj[rowId].inventoryDetails,
              previousLotNumberAllocationDetails: mappingObj[rowId]?.lotNumberAllocationDetails?.filter((val) => {
                if (Array(selectedData) && selectedData.length > 0) {
                  return !(selectedData?.filter((lot)=> lot?.lotNumber == val?.lotNumber).length > 0)
                } else {
                  return true
                }
              }).map((lot) => ({
                lotNumber: lot?.lotNumber,
                plannedAllocatedQuantity: 0,
              })),
              lotNumberAllocationDetails: selectedData?.map((lot) => ({
                lotNumber: lot.lotNumber,
                plannedAllocatedQuantity: Number(lot.plannedAllocatedQuantity),
              })),
            },
          ];
        }
      });
      dispatch({
        type: DESTROY_BACKDROP,
      });
    }, 1000);
  };

  //Update Component Allocation
  const handleUpdateComponentAllocation = () => {
    if (finalPayload.length > 0) {
      dispatch({
        type: OPEN_BACKDROP,
        backdropText: "Please don't refresh or close the tab while processing",
      });
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateComponentAllocation`;

      // console.log({
      //   schrockenSLID: SLID,
      //   componentAllocationDataList: finalPayload,
      //   cdmoOrgID: selectedRowData?.vendorMosymphonyID,
      // })
      axios
        .post(url, {
          schrockenSLID: SLID,
          componentAllocationDataList: finalPayload,
          cdmoOrgID: selectedRowData?.vendorMosymphonyID,
        })
        .then((res) => {
          if (res.data.status) {
            setOpenMsgDialog(true);
            // console.log("Update component allocation", res?.data);
          }
        })
        .catch((err) => {
          setError(err.message);
          console.error("Error=> ", err);
          setOpenMsgErrDialog(true);
        })
        .finally(() => {
          dispatch({
            type: DESTROY_BACKDROP,
          });
          setLotSelection({});
          setOpenRows({});
        });
    }
  };

  const handleUpdateOpen = () => {
    setOpenMsgDialog(true);
  };
  const handleUpdateClose = () => {
    setOpenMsgDialog(false);
    setRefreshTableData(!refreshTableData);
  };

  const handleErrUpdateOpen = () => {
    setOpenMsgErrDialog(true);
  };
  const handleErrUpdateClose = () => {
    setOpenMsgErrDialog(false);
  };
  const displayLoading = (
    <TableRow>
      <TableCell
        colSpan={localStorage.collabType === "Pharma Co" ? 8 : 7}
        align="center"
      >
        <CircularProgress color="primary" thickness={7} />
      </TableCell>
    </TableRow>
  );

  const tableError = (
    <TableRow
      style={{
        border: "2px solid #FF0000",
        backgroundColor: "#FFF0F0",
        marginTop: "10px",
      }}
    >
      <TableCell
        colSpan={localStorage.collabType === "Pharma Co" ? 8 : 7}
        align="center"
      >
        Something went wrong. Please try again later.
      </TableCell>
    </TableRow>
  );

  const noRecordsFoundMsgDisplay = (
    <TableRow>
      <TableCell
        colSpan={localStorage.collabType === "Pharma Co" ? 8 : 7}
        align="center"
      >
        No records found
      </TableCell>
    </TableRow>
  );

  return (
    <>
      <BackDropLoading />
      {/* Back button container */}
      <Grid container>
        <div className={classes.backContainer} onClick={handleBack}>
          <ArrowBackIosIcon aria-label="Go back" />
          <Typography style={{ marginLeft: "5px",fontWeight:'500' }}>Back</Typography>
        </div>
      </Grid>
      <hr />
      {/* Title container */}
      <Grid container mt={2} className={classes.titleContainer}>
        <Grid item lg={2} style={{ marginRight: "10px" }}>
          <Typography>
            <span style={{ fontWeight: 500 }}>BMS name</span> <br />
            <br /> {selectedRowData?.sponsorName}
          </Typography>
        </Grid>
        <Grid item lg={2} style={{ marginRight: "10px" }}>
          <Typography>
            <span style={{ fontWeight: 500 }}>CMO</span> <br />
            <br /> {selectedRowData?.vendorName}
          </Typography>
        </Grid>
        <Grid item lg={2}>
          <Typography>
            <span style={{ fontWeight: 500 }}>Product code / description</span>{" "}
            <br />
            <br /> {selectedRowData?.productCode} /{" "}
            {selectedRowData?.productName}
          </Typography>
        </Grid>
        <Grid item lg={1}>
          <Typography>
            <span style={{ fontWeight: 500 }}>PO quantity</span> <br />
            <br /> {selectedRowData?.targetQuantity}
          </Typography>
        </Grid>
        <Grid item lg={1}>
          <Typography>
            <span style={{ fontWeight: 500 }}>UOM</span> <br />
            <br /> {selectedRowData?.targetQuantityUOM}
          </Typography>
        </Grid>
        <Grid item lg={2}>
          <Typography>
            <span style={{ fontWeight: 500 }}>PO - line</span> <br />
            <br /> {selectedRowData?.poNumber} -{" "}
            {selectedRowData?.poLineItemNumber}
          </Typography>
        </Grid>
      </Grid>
      {/* Table container */}
      <Grid container>
        <Typography variant="h6">
        Component batch details
        <span className={classes.borders}></span>
        </Typography>
        <Grid item lg={12} sm={12} style={{ marginTop: "18px" }}>
          <TableContainer style={{ minHeight:'auto',maxHeight:'400px'}} component={Paper}>
            <Table stickyHeader style={{ tableLayout: "fixed", width: "100%" }} size="small">
              <TableHead>
                <TableRow style={{ backgroundColor: "#F0F0F0" }}>
                  {localStorage.collabType === "Pharma Co" && (
                    <TableCell style={{ width: "10px" }}></TableCell>
                  )}
                  <TableCell align="left">RM/PM code / description</TableCell>
                  <TableCell style={{ width: "75px" }} align="right">
                    Component qty.
                  </TableCell>
                  <TableCell style={{ width: "35px" }} align="left">
                    UoM
                  </TableCell>
                  <TableCell align="right">Net available qty.</TableCell>
                  <TableCell style={{ width: "85px" }} align="left">
                    Batch numbers
                  </TableCell>
                  <TableCell style={{ width: "85px" }} align="right">
                    Planned batch allocation
                  </TableCell>
                  <TableCell>Most recent change</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading
                  ? displayLoading
                  : error
                  ? tableError
                  : mainTableData?.length === 0
                  ? noRecordsFoundMsgDisplay
                  : mainTableData?.map((row, index) => {
                      let totalQuantity = 0;
                      // if (
                      //   row?.lotNumberAllocationDetails &&
                      //   row?.lotNumberAllocationDetails.length > 0
                      // ) {
                      //   for (let val of row?.lotNumberAllocationDetails) {
                      //     if (val?.plannedAllocatedQuantity) {
                      //       totalQuantity =
                      //         totalQuantity +
                      //         Number(val?.plannedAllocatedQuantity);
                      //     }
                      //   }
                      // }

                      // let totalSum = totalQuantity;
                      if (
                        lotSelection[
                          row?.componentAllocationDetails?.componentCode
                        ]?.lotAndValue
                      ) {
                        for (let [key, vals] of Object.entries(
                          lotSelection[
                            row?.componentAllocationDetails?.componentCode
                          ]?.lotAndValue
                        )) {
                          totalQuantity = totalQuantity + Number(vals);
                        }
                      }

                      totalQuantity = Number(totalQuantity).toFixed(3)
                      let componentQuantity = row?.componentAllocationDetails?.componentQuantity
                        ? Number(row?.componentAllocationDetails?.componentQuantity).toFixed(3)
                      : 0;
                      return (
                        <React.Fragment
                          key={row?.componentAllocationDetails?.componentCode}
                        >
                          {/* Main Row */}
                          <TableRow
                            style={{
                              backgroundColor:
                                index % 2 === 1 ? "#F0F0F0" : "white",
                            }}
                          >
                            {localStorage.collabType === "Pharma Co" && (
                              <TableCell>
                                <IconButton
                                  onClick={() =>
                                    handleRowToggle(
                                      row?.componentAllocationDetails
                                        ?.componentCode
                                    )
                                  }
                                  size="small"
                                >
                                  {openRows[
                                    row?.componentAllocationDetails
                                      ?.componentCode
                                  ] ? (
                                    <ExpandMoreIcon />
                                  ) : (
                                    <ChevronRightIcon />
                                  )}
                                </IconButton>
                              </TableCell>
                            )}

                            <TableCell align="left">
                              {row?.componentAllocationDetails?.componentCode} /
                              {row?.componentAllocationDetails?.componentName}
                              
                            </TableCell>
                            <TableCell align="right">
                              {
                                row?.componentAllocationDetails
                                  ?.componentQuantity
                              }
                            </TableCell>
                            <TableCell align="left">
                              {row?.componentAllocationDetails?.uom
                                ? row?.componentAllocationDetails?.uom
                                : "-"}
                            </TableCell>
                            <TableCell align="right">
                              {/* {(row?.componentAllocationDetails?.netAvailableQuantity).toLocaleString(
                              "en-US"
                            )} */}
                              {row?.componentAllocationDetails
                                ?.netAvailableQuantity
                                ? Number(
                                    row?.componentAllocationDetails?.netAvailableQuantity.toFixed(
                                      3
                                    )
                                  ).toLocaleString("en-US")
                                : "NA"}
                            </TableCell>
                            <TableCell align="left">
                              {row?.lotNumberAllocationDetails?.length > 0
                                ? row.lotNumberAllocationDetails.map(
                                    (val, index) =>
                                      val?.lotNumber ? (
                                        <p key={index}>{val.lotNumber}</p>
                                      ) : (
                                        <p key={index}>NA</p>
                                      )
                                  )
                                : "NA"}
                            </TableCell>

                            <TableCell align="right">
                              {row?.lotNumberAllocationDetails?.length > 0
                                ? row.lotNumberAllocationDetails.map(
                                    (val, index) =>
                                      (val?.plannedAllocatedQuantity || val.plannedAllocatedQuantity == 0) ? (
                                        <p key={index}>
                                        {val.plannedAllocatedQuantity % 1 !== 0 ? Number(val.plannedAllocatedQuantity).toFixed(3) : val.plannedAllocatedQuantity}
                                        </p>
                                      ) : (
                                        <p key={index}>NA</p>
                                      )
                                  )
                                : "NA"}
                            </TableCell>

                            <TableCell>
                              {row?.componentAllocationDetails?.lastUpdatedDate
                                ? new Date(
                                    row?.componentAllocationDetails?.lastUpdatedDate
                                  )
                                    .toLocaleString("en-GB", {
                                      day: "2-digit",
                                      month: "short",
                                      year: "numeric",
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      second: "2-digit",
                                      hour12: false,
                                    })
                                    .replace(/([a-z]+)/i, (match) =>
                                      match.toUpperCase()
                                    )
                                : "NA"}
                            </TableCell>
                          </TableRow>

                          {/* Collapsible Row */}
                          {openRows[
                            row?.componentAllocationDetails?.componentCode
                          ] && (
                            <TableRow style={{ backgroundColor: "#FAFAFA" }}>
                              <TableCell colSpan={8}>
                                <Grid
                                  container
                                  spacing={4}
                                  alignItems="flex-start"
                                >
                                  {/* Nested Table */}
                                  <Grid item xs={7}>
                                    <TableContainer
                                      component={Paper}
                                      style={{ border: "2px solid #ccc" }}
                                    >
                                      <Table size="small">
                                        <TableHead>
                                          <TableRow>
                                            <TableCell
                                              style={{ width: "50px" }}
                                            >
                                              Selection
                                            </TableCell>
                                            <TableCell
                                              style={{ width: "80px" }}
                                            >
                                              Batch no.
                                            </TableCell>
                                            <TableCell
                                              style={{ width: "110px" }}
                                            >
                                              Net available qty.
                                            </TableCell>
                                            <TableCell
                                              style={{ width: "75px" }}
                                            >
                                              Expiry date
                                            </TableCell>
                                            {!(
                                              lotSelection[
                                                row?.componentAllocationDetails
                                                  ?.componentCode
                                              ]?.useSingleLot ?? true
                                            ) && (
                                              <TableCell
                                                style={{ width: "125px" }}
                                              >
                                                Quantity to be used
                                              </TableCell>
                                            )}
                                          </TableRow>
                                        </TableHead>
                                        <TableBody>
                                          {row?.inventoryDetails?.map((lot) => {
                                            return (
                                              <TableRow
                                                key={lot?.inventoryBatchNumber}
                                              >
                                                <TableCell>
                                                  {lotSelection[
                                                    row
                                                      ?.componentAllocationDetails
                                                      ?.componentCode
                                                  ]?.useSingleLot ?? true ? (
                                                    <Checkbox
                                                      checked={
                                                        lotSelection[
                                                          row
                                                            ?.componentAllocationDetails
                                                            ?.componentCode
                                                        ]?.selectedLot ===
                                                        lot.inventoryBatchNumber
                                                      }
                                                      disabled={ lot?.netAvailableQuantity < componentQuantity}
                                                      onChange={() => {
                                                        handleSelectionChange(
                                                          row
                                                            ?.componentAllocationDetails
                                                            ?.componentCode,
                                                          lot.inventoryBatchNumber,
                                                          row
                                                            ?.componentAllocationDetails
                                                            ?.componentQuantity
                                                        );
                                                      }}
                                                    />
                                                  ) : (
                                                    <Checkbox
                                                      checked={
                                                        lotSelection[
                                                          row
                                                            ?.componentAllocationDetails
                                                            .componentCode
                                                        ]?.selectedLots?.includes(
                                                          lot?.inventoryBatchNumber
                                                        ) ?? false
                                                      }
                                                      disabled={
                                                        totalQuantity >=
                                                        componentQuantity
                                                      }
                                                      onChange={() =>
                                                        handleSelectionChange(
                                                          row
                                                            ?.componentAllocationDetails
                                                            ?.componentCode,
                                                          lot?.inventoryBatchNumber,
                                                          row
                                                            ?.componentAllocationDetails
                                                            ?.componentQuantity
                                                        )
                                                      }
                                                    />
                                                  )}
                                                </TableCell>
                                                <TableCell>
                                                  {lot?.inventoryBatchNumber}
                                                </TableCell>
                                                <TableCell>
                                                  {(lot?.netAvailableQuantity).toLocaleString(
                                                    "en-US"
                                                  )}
                                                </TableCell>
                                                <TableCell>
                                                  {lot?.inventoryExpiryDate
                                                    ? new Date(
                                                        lot?.inventoryExpiryDate
                                                      )
                                                        .toLocaleDateString(
                                                          "en-GB",
                                                          {
                                                            day: "2-digit",
                                                            month: "short",
                                                            year: "numeric",
                                                          }
                                                        )
                                                        .toUpperCase()
                                                        .replace(" ", "-")
                                                    : "--"}
                                                </TableCell>

                                                {!(
                                                  lotSelection[
                                                    row
                                                      .componentAllocationDetails
                                                      .componentCode
                                                  ]?.useSingleLot ?? true
                                                ) && (
                                                  <TableCell>
                                                    <TextField
                                                      variant="outlined"
                                                      style={{ padding: "5px" }}
                                                      inputProps={{
                                                        style: {
                                                          height: "15px",
                                                          padding: "5px 10px",
                                                        },
                                                      }}
                                                      disabled={
                                                        !lotSelection[
                                                          row
                                                            ?.componentAllocationDetails
                                                            .componentCode
                                                        ]?.selectedLots?.includes(
                                                          lot?.inventoryBatchNumber
                                                        )
                                                      }
                                                      value={
                                                        lotSelection[
                                                          row
                                                            ?.componentAllocationDetails
                                                            ?.componentCode
                                                        ]?.lotAndValue?.[
                                                          lot
                                                            ?.inventoryBatchNumber
                                                        ]
                                                          ? lotSelection[
                                                              row
                                                                ?.componentAllocationDetails
                                                                ?.componentCode
                                                            ]?.lotAndValue?.[
                                                              lot
                                                                ?.inventoryBatchNumber
                                                            ]
                                                          : ""
                                                      }
                                                      onChange={(e) => {
                                                        if (
                                                          /^\d*\.?\d*$/.test(
                                                            e.target.value
                                                          )
                                                        ) {
                                                          handleQtyChange(
                                                            e.target.value,
                                                            row
                                                              ?.componentAllocationDetails
                                                              ?.componentCode,
                                                            lot?.inventoryBatchNumber,
                                                            row
                                                              ?.componentAllocationDetails
                                                              ?.componentQuantity,
                                                            row.lotNumberAllocationDetails
                                                          );
                                                        }
                                                      }}
                                                    ></TextField>
                                                  </TableCell>
                                                )}
                                              </TableRow>
                                            );
                                          })}
                                        </TableBody>
                                      </Table>
                                    </TableContainer>
                                    <p
                                      style={{
                                        fontSize: "0.8rem",
                                        marginLeft: "5px",
                                      }}
                                    >
                                      {lotSelection[
                                        row.componentAllocationDetails
                                          .componentCode
                                      ]?.useSingleLot ?? true
                                        ? "Note - Only those batch numbers that have net available quantity more than the BoM quantity can be selected."
                                        : "Note - BoM quantity and total quantity to be used need to match."}
                                    </p>
                                  </Grid>
                                  {/* CheckBox */}
                                  <Grid
                                    item
                                    xs={5}
                                    container
                                    direction="column"
                                    alignItems="flex-start"
                                    justifyContent="space-between"
                                    style={{ height: "100%" }}
                                  >
                                    <Box
                                      sx={{
                                        border: "2px solid #ccc",
                                        padding: "3px",
                                        borderRadius: "4px",
                                        width: "80%",
                                      }}
                                    >
                                      <FormControlLabel
                                        control={
                                          <Checkbox
                                            checked={
                                              lotSelection[
                                                row.componentAllocationDetails
                                                  .componentCode
                                              ]?.useSingleLot ?? true
                                            }
                                            // disabled={
                                            //   totalQuantity >=
                                            //   componentQuantity
                                            // }
                                            onChange={(e) =>
                                              handleToggleSingleLot(
                                                row.componentAllocationDetails
                                                  .componentCode,
                                                e.target.checked
                                              )
                                            }
                                          />
                                        }
                                        label="Use RM/PM material from one batch only"
                                      />
                                    </Box>

                                    {/* Save Changes Button */}
                                    <Button
                                      // disabled={disableSaveChangesBtn || (totalQuantity >= componentQuantity)}
                                      // disabled={(totalSum !== componentQuantity) || (totalQuantity >= componentQuantity)}
                                      disabled={(totalQuantity !== componentQuantity)}
                                      variant="contained"
                                      color="primary"
                                      onClick={() =>
                                        handleSaveChanges(
                                          row?.componentAllocationDetails
                                            .componentCode,
                                          row?.inventoryDetails
                                        )
                                      }
                                      style={{
                                        marginTop: "55px",
                                        borderRadius: "25px",
                                        textTransform: "none",
                                      }}
                                    >
                                      Save changes
                                      <ChevronRightIcon />
                                    </Button>
                                  </Grid>
                                </Grid>
                              </TableCell>
                            </TableRow>
                          )}
                        </React.Fragment>
                      );
                    })}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
      {/* Final Button */}
      <Grid container>
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleUpdateComponentAllocation()}
          style={{
            marginTop: "40px",
            borderRadius: "25px",
            textTransform: "none",
          }}
          disabled={finalPayload.length === 0}
        >
          Update changes
          <ChevronRightIcon />
        </Button>
      </Grid>

      {/* For Success Message */}
      <Dialog
        open={openMsgDialog}
        onClose={handleUpdateOpen}
        maxWidth="sm"
        fullWidth
      >
        <StyledDialog
          title="Changes updated successfully"
          icon={false} // false for success (CheckCircle), true for error (CancelIcon)
          handleClose={handleUpdateClose}
          isButtonDisabled={false} // If you want to disable the OK button
        />
      </Dialog>

      <Dialog
        open={openMsgErrDialog}
        onClose={handleErrUpdateOpen}
        maxWidth="sm"
        fullWidth
      >
        <StyledDialog
          title="Something went wrong"
          icon={true} // false for success (CheckCircle), true for error (CancelIcon)
          handleClose={handleErrUpdateClose}
          isButtonDisabled={false} // If you want to disable the OK button
        />
      </Dialog>
    </>
  );
}
